{
  "hiLinkTypes": {
    "raw": "Индикатор метрики (metric)",
    "calculate": "Расчетный (calc)",
    "event": "Событие (event)",
    "alert_hint": "Индикатор метрики (ci_hint)",
    "event_hint": "Событие (event)",
    "static": "Статус КЕ (static)"
  },
  "hiStatusValues": {
    "noData": "Нет данных",
    "ok": "Ок",
    "warning": "Предупреждение",
    "error": "Ошибка",
    "criticalError": "Критический",
    "service": "Обслуживание"
  }
}